import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const BottomNav = ({ menu }) => {
    return (
        <div
            className="
            md:hidden
            fixed
            bottom-0
            left-0
            right-0
            bg-white
            border-t
            shadow-lg
            flex
            justify-around
            py-2
            z-50
            "
        >

            {menu.map((item) => (
                
                // !item?.showOnlyComputer &&
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end
                        className={({ isActive }) =>
                            `
                            flex flex-col items-center text-xs gap-1
                            ${isActive
                                ? "text-[#543389]"
                                : "text-slate-500"}
                            `
                        }
                    >
                        <ReactSVG src={`${process.env.PUBLIC_URL}${item.icon}`} className="w-5 h-5"/>
                        <span className="font-bold">{item.title}</span>
                    </NavLink>
            ))}

        </div>
    );
};

export default BottomNav